import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=37951da8&scoped=true&"
import script from "./CategoryForm.vue?vue&type=script&lang=ts&"
export * from "./CategoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=37951da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37951da8",
  null
  
)

export default component.exports